/* @generated from adl module totalinteraction.futurefit.frontend */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as sys_types from './../../sys/types';
import * as totalinteraction_futurefit_db from './db';

/**
 * A Competency (Cloned extract of totalinteraction.futurefit.db.Competency)
 */
export interface Competency {
  /**
   * Display name - depending on location, may need to be abbreviated
   */
  name: totalinteraction_futurefit_db.I18nContent;
  /**
   * Full name
   */
  fullName: totalinteraction_futurefit_db.I18nContent;
  /**
   * Long description definition
   */
  definition: totalinteraction_futurefit_db.I18nContent;
  /**
   * Order of competencies
   */
  ordering: number;
}

export function makeCompetency(
  input: {
    name: totalinteraction_futurefit_db.I18nContent,
    fullName: totalinteraction_futurefit_db.I18nContent,
    definition: totalinteraction_futurefit_db.I18nContent,
    ordering: number,
  }
): Competency {
  return {
    name: input.name,
    fullName: input.fullName,
    definition: input.definition,
    ordering: input.ordering,
  };
}

const Competency_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"fullName","default":{"kind":"nothing"},"name":"fullName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"definition","default":{"kind":"nothing"},"name":"definition","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"ordering","default":{"kind":"nothing"},"name":"ordering","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"Competency","version":{"kind":"nothing"}}};

export const snCompetency: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Competency"};

export function texprCompetency(): ADL.ATypeExpr<Competency> {
  return {value : {typeRef : {kind: "reference", value : snCompetency}, parameters : []}};
}

/**
 * Pack of dereferenced skills and competencies for the frontend to refer to
 */
export interface CompetencySkillsMap {
  /**
   * Map of competencies by competencyId
   */
  competencies: common.StringKeyMap<common.Key<Competency>, Competency>;
  /**
   * Map of skills by skillId
   */
  skills: common.StringKeyMap<common.Key<totalinteraction_futurefit_db.Skill>, totalinteraction_futurefit_db.Skill>;
  /**
   * skillIds for each competency
   */
  skillsByCompetency: common.StringKeyMap<common.Key<Competency>, common.Key<totalinteraction_futurefit_db.Skill>[]>;
}

export function makeCompetencySkillsMap(
  input: {
    competencies: common.StringKeyMap<common.Key<Competency>, Competency>,
    skills: common.StringKeyMap<common.Key<totalinteraction_futurefit_db.Skill>, totalinteraction_futurefit_db.Skill>,
    skillsByCompetency: common.StringKeyMap<common.Key<Competency>, common.Key<totalinteraction_futurefit_db.Skill>[]>,
  }
): CompetencySkillsMap {
  return {
    competencies: input.competencies,
    skills: input.skills,
    skillsByCompetency: input.skillsByCompetency,
  };
}

const CompetencySkillsMap_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"competencies","default":{"kind":"nothing"},"name":"competencies","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Competency"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Competency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skills","default":{"kind":"nothing"},"name":"skills","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillsByCompetency","default":{"kind":"nothing"},"name":"skillsByCompetency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Competency"}},"parameters":[]}]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}]}}]}},"name":"CompetencySkillsMap","version":{"kind":"nothing"}}};

export const snCompetencySkillsMap: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"CompetencySkillsMap"};

export function texprCompetencySkillsMap(): ADL.ATypeExpr<CompetencySkillsMap> {
  return {value : {typeRef : {kind: "reference", value : snCompetencySkillsMap}, parameters : []}};
}

/**
 * Scores by competency and by skill. Not necessarily for a Quiz, if only
 * 'expected' and 'industryAverage' are included it could be for a WorkRole
 */
export interface ResultsScoreSet {
  /**
   * Descriptive title of result set
   */
  title: string;
  /**
   * Aggregated score overall
   */
  overall: totalinteraction_futurefit_db.Score;
  /**
   * Scores by competency id
   */
  byCompetency: common.StringKeyMap<common.Key<Competency>, totalinteraction_futurefit_db.Score>;
  /**
   * Scores by skill id
   */
  bySkill: common.StringKeyMap<common.Key<totalinteraction_futurefit_db.Skill>, totalinteraction_futurefit_db.Score>;
}

export function makeResultsScoreSet(
  input: {
    title: string,
    overall: totalinteraction_futurefit_db.Score,
    byCompetency: common.StringKeyMap<common.Key<Competency>, totalinteraction_futurefit_db.Score>,
    bySkill: common.StringKeyMap<common.Key<totalinteraction_futurefit_db.Skill>, totalinteraction_futurefit_db.Score>,
  }
): ResultsScoreSet {
  return {
    title: input.title,
    overall: input.overall,
    byCompetency: input.byCompetency,
    bySkill: input.bySkill,
  };
}

const ResultsScoreSet_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"overall","default":{"kind":"nothing"},"name":"overall","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}},{"annotations":[],"serializedName":"byCompetency","default":{"kind":"nothing"},"name":"byCompetency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Competency"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bySkill","default":{"kind":"nothing"},"name":"bySkill","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}}]}},"name":"ResultsScoreSet","version":{"kind":"nothing"}}};

export const snResultsScoreSet: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"ResultsScoreSet"};

export function texprResultsScoreSet(): ADL.ATypeExpr<ResultsScoreSet> {
  return {value : {typeRef : {kind: "reference", value : snResultsScoreSet}, parameters : []}};
}

/**
 * Quiz-specific and quiz-wide data, loaded only once
 */
export interface QuizMapAndScores {
  /**
   * Full Quiz record
   */
  quiz: common_db.WithDbId<totalinteraction_futurefit_db.Quiz>;
  /**
   * Score ranges from associated WorkRole
   */
  ranges: totalinteraction_futurefit_db.WorkRoleScoreRange[];
  map: CompetencySkillsMap;
  /**
   * Subset of quiz results datasets, covering just
   * expected and industry average
   */
  datasets: {[key: string]: ResultsScoreSet};
  skillGroups: {[key: string]: common_db.DbKey<totalinteraction_futurefit_db.Skill>[]};
}

export function makeQuizMapAndScores(
  input: {
    quiz: common_db.WithDbId<totalinteraction_futurefit_db.Quiz>,
    ranges: totalinteraction_futurefit_db.WorkRoleScoreRange[],
    map: CompetencySkillsMap,
    datasets: {[key: string]: ResultsScoreSet},
    skillGroups: {[key: string]: common_db.DbKey<totalinteraction_futurefit_db.Skill>[]},
  }
): QuizMapAndScores {
  return {
    quiz: input.quiz,
    ranges: input.ranges,
    map: input.map,
    datasets: input.datasets,
    skillGroups: input.skillGroups,
  };
}

const QuizMapAndScores_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quiz","default":{"kind":"nothing"},"name":"quiz","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"ranges","default":{"kind":"nothing"},"name":"ranges","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRoleScoreRange"}},"parameters":[]}]}},{"annotations":[],"serializedName":"map","default":{"kind":"nothing"},"name":"map","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"CompetencySkillsMap"}},"parameters":[]}},{"annotations":[],"serializedName":"datasets","default":{"kind":"nothing"},"name":"datasets","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"ResultsScoreSet"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillGroups","default":{"kind":"nothing"},"name":"skillGroups","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}]}}]}},"name":"QuizMapAndScores","version":{"kind":"nothing"}}};

export const snQuizMapAndScores: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"QuizMapAndScores"};

export function texprQuizMapAndScores(): ADL.ATypeExpr<QuizMapAndScores> {
  return {value : {typeRef : {kind: "reference", value : snQuizMapAndScores}, parameters : []}};
}

/**
 * Role-specific - doesn't look at Quiz data at all
 */
export interface RoleMapAndScores {
  /**
   * Full Role record
   */
  role: common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>;
  map: CompetencySkillsMap;
  /**
   * Data taken from WorkRoleSkill
   */
  datasets: {[key: string]: ResultsScoreSet};
  skillGroups: {[key: string]: common_db.DbKey<totalinteraction_futurefit_db.Skill>[]};
}

export function makeRoleMapAndScores(
  input: {
    role: common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>,
    map: CompetencySkillsMap,
    datasets: {[key: string]: ResultsScoreSet},
    skillGroups: {[key: string]: common_db.DbKey<totalinteraction_futurefit_db.Skill>[]},
  }
): RoleMapAndScores {
  return {
    role: input.role,
    map: input.map,
    datasets: input.datasets,
    skillGroups: input.skillGroups,
  };
}

const RoleMapAndScores_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"role","default":{"kind":"nothing"},"name":"role","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"map","default":{"kind":"nothing"},"name":"map","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"CompetencySkillsMap"}},"parameters":[]}},{"annotations":[],"serializedName":"datasets","default":{"kind":"nothing"},"name":"datasets","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"ResultsScoreSet"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillGroups","default":{"kind":"nothing"},"name":"skillGroups","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}]}}]}},"name":"RoleMapAndScores","version":{"kind":"nothing"}}};

export const snRoleMapAndScores: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RoleMapAndScores"};

export function texprRoleMapAndScores(): ADL.ATypeExpr<RoleMapAndScores> {
  return {value : {typeRef : {kind: "reference", value : snRoleMapAndScores}, parameters : []}};
}

/**
 * (Sanitised) cloned subset of AppUser
 */
export interface AppUserData {
  fullname: string;
  email: string;
}

export function makeAppUserData(
  input: {
    fullname: string,
    email: string,
  }
): AppUserData {
  return {
    fullname: input.fullname,
    email: input.email,
  };
}

const AppUserData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"AppUserData","version":{"kind":"nothing"}}};

export const snAppUserData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"AppUserData"};

export function texprAppUserData(): ADL.ATypeExpr<AppUserData> {
  return {value : {typeRef : {kind: "reference", value : snAppUserData}, parameters : []}};
}

/**
 * Mapping between users and groups - So that UI selector can list names of users and groups and determine Set<DbKey<AppUser>> from Set<DbKey<UserGroup>>
 */
export interface UsersGroupsMap {
  appUsers: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, AppUserData>;
  userGroups: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.UserGroup>, totalinteraction_futurefit_db.UserGroup>;
  groupsByUser: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, common_db.DbKey<totalinteraction_futurefit_db.UserGroup>[]>;
  usersByGroup: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.UserGroup>, common_db.DbKey<totalinteraction_futurefit_db.AppUser>[]>;
}

export function makeUsersGroupsMap(
  input: {
    appUsers: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, AppUserData>,
    userGroups: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.UserGroup>, totalinteraction_futurefit_db.UserGroup>,
    groupsByUser: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, common_db.DbKey<totalinteraction_futurefit_db.UserGroup>[]>,
    usersByGroup: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.UserGroup>, common_db.DbKey<totalinteraction_futurefit_db.AppUser>[]>,
  }
): UsersGroupsMap {
  return {
    appUsers: input.appUsers,
    userGroups: input.userGroups,
    groupsByUser: input.groupsByUser,
    usersByGroup: input.usersByGroup,
  };
}

const UsersGroupsMap_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUsers","default":{"kind":"nothing"},"name":"appUsers","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"AppUserData"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userGroups","default":{"kind":"nothing"},"name":"userGroups","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}},{"annotations":[],"serializedName":"groupsByUser","default":{"kind":"nothing"},"name":"groupsByUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"usersByGroup","default":{"kind":"nothing"},"name":"usersByGroup","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}]}]}}]}},"name":"UsersGroupsMap","version":{"kind":"nothing"}}};

export const snUsersGroupsMap: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"UsersGroupsMap"};

export function texprUsersGroupsMap(): ADL.ATypeExpr<UsersGroupsMap> {
  return {value : {typeRef : {kind: "reference", value : snUsersGroupsMap}, parameters : []}};
}

/**
 * API response object for data for a participant's quiz results
 */
export interface UserQuizResults {
  /**
   * User context info:
   */
  appUserId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>;
  appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>;
  fullname: common_strings.StringNE;
  /**
   * Results for a given UserQuiz:
   */
  userQuizId: common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>;
  /**
   * collection of named datasets - Names to provide datasets as
   *  requested - names to match up with styling keys in frontend
   */
  datasets: {[key: string]: ResultsScoreSet};
}

export function makeUserQuizResults(
  input: {
    appUserId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>,
    appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>,
    fullname: common_strings.StringNE,
    userQuizId: common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>,
    datasets: {[key: string]: ResultsScoreSet},
  }
): UserQuizResults {
  return {
    appUserId: input.appUserId,
    appClientId: input.appClientId,
    fullname: input.fullname,
    userQuizId: input.userQuizId,
    datasets: input.datasets,
  };
}

const UserQuizResults_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"datasets","default":{"kind":"nothing"},"name":"datasets","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"ResultsScoreSet"}},"parameters":[]}]}}]}},"name":"UserQuizResults","version":{"kind":"nothing"}}};

export const snUserQuizResults: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"UserQuizResults"};

export function texprUserQuizResults(): ADL.ATypeExpr<UserQuizResults> {
  return {value : {typeRef : {kind: "reference", value : snUserQuizResults}, parameters : []}};
}

export interface SingleUserQuizResults {
  /**
   * single user-specific data
   */
  quizResults: UserQuizResults;
  /**
   * quiz and quiz-contextual data
   */
  quizMapAndScores: QuizMapAndScores;
}

export function makeSingleUserQuizResults(
  input: {
    quizResults: UserQuizResults,
    quizMapAndScores: QuizMapAndScores,
  }
): SingleUserQuizResults {
  return {
    quizResults: input.quizResults,
    quizMapAndScores: input.quizMapAndScores,
  };
}

const SingleUserQuizResults_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quizResults","default":{"kind":"nothing"},"name":"quizResults","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"UserQuizResults"}},"parameters":[]}},{"annotations":[],"serializedName":"quizMapAndScores","default":{"kind":"nothing"},"name":"quizMapAndScores","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"QuizMapAndScores"}},"parameters":[]}}]}},"name":"SingleUserQuizResults","version":{"kind":"nothing"}}};

export const snSingleUserQuizResults: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SingleUserQuizResults"};

export function texprSingleUserQuizResults(): ADL.ATypeExpr<SingleUserQuizResults> {
  return {value : {typeRef : {kind: "reference", value : snSingleUserQuizResults}, parameters : []}};
}

/**
 * API response for multiple user quiz results
 */
export interface MultiUserQuizResults {
  /**
   * multiple users' user-specific data
   */
  quizResults: UserQuizResults[];
  /**
   * quiz and quiz-contextual data
   */
  quizMapAndScores: QuizMapAndScores;
}

export function makeMultiUserQuizResults(
  input: {
    quizResults: UserQuizResults[],
    quizMapAndScores: QuizMapAndScores,
  }
): MultiUserQuizResults {
  return {
    quizResults: input.quizResults,
    quizMapAndScores: input.quizMapAndScores,
  };
}

const MultiUserQuizResults_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quizResults","default":{"kind":"nothing"},"name":"quizResults","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"UserQuizResults"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizMapAndScores","default":{"kind":"nothing"},"name":"quizMapAndScores","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"QuizMapAndScores"}},"parameters":[]}}]}},"name":"MultiUserQuizResults","version":{"kind":"nothing"}}};

export const snMultiUserQuizResults: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"MultiUserQuizResults"};

export function texprMultiUserQuizResults(): ADL.ATypeExpr<MultiUserQuizResults> {
  return {value : {typeRef : {kind: "reference", value : snMultiUserQuizResults}, parameters : []}};
}

export interface ComparisonRoles {
  roles: common.StringKeyMap<common.Key<totalinteraction_futurefit_db.WorkRole>, RoleData>;
}

export function makeComparisonRoles(
  input: {
    roles: common.StringKeyMap<common.Key<totalinteraction_futurefit_db.WorkRole>, RoleData>,
  }
): ComparisonRoles {
  return {
    roles: input.roles,
  };
}

const ComparisonRoles_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Key"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"RoleData"}},"parameters":[]}]}}]}},"name":"ComparisonRoles","version":{"kind":"nothing"}}};

export const snComparisonRoles: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"ComparisonRoles"};

export function texprComparisonRoles(): ADL.ATypeExpr<ComparisonRoles> {
  return {value : {typeRef : {kind: "reference", value : snComparisonRoles}, parameters : []}};
}

/**
 * @deprecated this should be renamed (@see totalinteraction.futurefit.requests.WorkRoleData)
 */
export interface RoleData {
  workRole: common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>;
  expected: ResultsScoreSet;
}

export function makeRoleData(
  input: {
    workRole: common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>,
    expected: ResultsScoreSet,
  }
): RoleData {
  return {
    workRole: input.workRole,
    expected: input.expected,
  };
}

const RoleData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workRole","default":{"kind":"nothing"},"name":"workRole","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expected","default":{"kind":"nothing"},"name":"expected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"ResultsScoreSet"}},"parameters":[]}}]}},"name":"RoleData","version":{"kind":"nothing"}}};

export const snRoleData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RoleData"};

export function texprRoleData(): ADL.ATypeExpr<RoleData> {
  return {value : {typeRef : {kind: "reference", value : snRoleData}, parameters : []}};
}

/**
 * Data for My Assessments screen
 */
export interface UserQuizData {
  /**
   * User context info:
   */
  appUserId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>;
  fullname: common_strings.StringNE;
  /**
   * Summary data on users' own quizzes
   */
  userQuizzes: UserQuizSummary[];
}

export function makeUserQuizData(
  input: {
    appUserId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>,
    fullname: common_strings.StringNE,
    userQuizzes: UserQuizSummary[],
  }
): UserQuizData {
  return {
    appUserId: input.appUserId,
    fullname: input.fullname,
    userQuizzes: input.userQuizzes,
  };
}

const UserQuizData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"userQuizzes","default":{"kind":"nothing"},"name":"userQuizzes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"UserQuizSummary"}},"parameters":[]}]}}]}},"name":"UserQuizData","version":{"kind":"nothing"}}};

export const snUserQuizData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"UserQuizData"};

export function texprUserQuizData(): ADL.ATypeExpr<UserQuizData> {
  return {value : {typeRef : {kind: "reference", value : snUserQuizData}, parameters : []}};
}

/**
 * Summary data about a UserQuiz
 */
export interface UserQuizSummary {
  /**
   * Title from Quiz.title OR Name from WorkRole.name
   */
  title: totalinteraction_futurefit_db.I18nContent;
  /**
   * Image Url from Quiz.imageUrl
   */
  imageUrl: string;
  /**
   * For retrieval:
   */
  userId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>;
  userQuizId: common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>;
  quizId: common_db.DbKey<totalinteraction_futurefit_db.Quiz>;
  quizType: totalinteraction_futurefit_db.QuizType;
  roleId: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>;
  /**
   * computed status from UserQuiz fields
   */
  status: AssessmentStatus;
  /**
   * Use to prevent immediate access to results
   */
  lockResults: boolean;
  /**
   * For displayed count while running a quiz, discount the intro and outro 'slides'
   * 'true' if they exist
   */
  introduction: boolean;
  conclusion: boolean;
}

export function makeUserQuizSummary(
  input: {
    title: totalinteraction_futurefit_db.I18nContent,
    imageUrl: string,
    userId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>,
    userQuizId: common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>,
    quizId: common_db.DbKey<totalinteraction_futurefit_db.Quiz>,
    quizType: totalinteraction_futurefit_db.QuizType,
    roleId: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>,
    status: AssessmentStatus,
    lockResults: boolean,
    introduction: boolean,
    conclusion: boolean,
  }
): UserQuizSummary {
  return {
    title: input.title,
    imageUrl: input.imageUrl,
    userId: input.userId,
    userQuizId: input.userQuizId,
    quizId: input.quizId,
    quizType: input.quizType,
    roleId: input.roleId,
    status: input.status,
    lockResults: input.lockResults,
    introduction: input.introduction,
    conclusion: input.conclusion,
  };
}

const UserQuizSummary_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"imageUrl","default":{"kind":"nothing"},"name":"imageUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizId","default":{"kind":"nothing"},"name":"quizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizType","default":{"kind":"nothing"},"name":"quizType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizType"}},"parameters":[]}},{"annotations":[],"serializedName":"roleId","default":{"kind":"nothing"},"name":"roleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"AssessmentStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"lockResults","default":{"kind":"nothing"},"name":"lockResults","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"introduction","default":{"kind":"nothing"},"name":"introduction","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"conclusion","default":{"kind":"nothing"},"name":"conclusion","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"UserQuizSummary","version":{"kind":"nothing"}}};

export const snUserQuizSummary: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"UserQuizSummary"};

export function texprUserQuizSummary(): ADL.ATypeExpr<UserQuizSummary> {
  return {value : {typeRef : {kind: "reference", value : snUserQuizSummary}, parameters : []}};
}

export interface AssessmentStatus {
  progress: number;
  total: number;
  completedAt: (common.Instant|null);
}

export function makeAssessmentStatus(
  input: {
    progress: number,
    total: number,
    completedAt: (common.Instant|null),
  }
): AssessmentStatus {
  return {
    progress: input.progress,
    total: input.total,
    completedAt: input.completedAt,
  };
}

const AssessmentStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"progress","default":{"kind":"nothing"},"name":"progress","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"completedAt","default":{"kind":"nothing"},"name":"completedAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"AssessmentStatus","version":{"kind":"nothing"}}};

export const snAssessmentStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"AssessmentStatus"};

export function texprAssessmentStatus(): ADL.ATypeExpr<AssessmentStatus> {
  return {value : {typeRef : {kind: "reference", value : snAssessmentStatus}, parameters : []}};
}

/**
 * Question/Intro/Conclusion information as it will be presented
 */
export interface QuizNextQuestion {
  quizQuestionId: common_db.DbKey<totalinteraction_futurefit_db.QuizQuestion>;
  /**
   * Embedded sub-category: will contain linked TrainingOfferingId...
   */
  category: totalinteraction_futurefit_db.QuestionCategory;
  /**
   * ... In which case this field is effectively ignored
   */
  content: totalinteraction_futurefit_db.I18nContent;
  answerType: AnswerType;
  answers: totalinteraction_futurefit_db.I18nContent[];
  questionNumber: number;
  totalQuestions: number;
}

export function makeQuizNextQuestion(
  input: {
    quizQuestionId: common_db.DbKey<totalinteraction_futurefit_db.QuizQuestion>,
    category: totalinteraction_futurefit_db.QuestionCategory,
    content: totalinteraction_futurefit_db.I18nContent,
    answerType: AnswerType,
    answers: totalinteraction_futurefit_db.I18nContent[],
    questionNumber: number,
    totalQuestions: number,
  }
): QuizNextQuestion {
  return {
    quizQuestionId: input.quizQuestionId,
    category: input.category,
    content: input.content,
    answerType: input.answerType,
    answers: input.answers,
    questionNumber: input.questionNumber,
    totalQuestions: input.totalQuestions,
  };
}

const QuizNextQuestion_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quizQuestionId","default":{"kind":"nothing"},"name":"quizQuestionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizQuestion"}},"parameters":[]}]}},{"annotations":[],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuestionCategory"}},"parameters":[]}},{"annotations":[],"serializedName":"content","default":{"kind":"nothing"},"name":"content","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"answerType","default":{"kind":"nothing"},"name":"answerType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"AnswerType"}},"parameters":[]}},{"annotations":[],"serializedName":"answers","default":{"kind":"nothing"},"name":"answers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"questionNumber","default":{"kind":"nothing"},"name":"questionNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"totalQuestions","default":{"kind":"nothing"},"name":"totalQuestions","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"QuizNextQuestion","version":{"kind":"nothing"}}};

export const snQuizNextQuestion: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"QuizNextQuestion"};

export function texprQuizNextQuestion(): ADL.ATypeExpr<QuizNextQuestion> {
  return {value : {typeRef : {kind: "reference", value : snQuizNextQuestion}, parameters : []}};
}

export interface SelfAssessmentNextQuestion {
  competency: common_db.WithDbId<totalinteraction_futurefit_db.Competency>;
  skillQuestions: sys_types.Pair<common_db.DbKey<totalinteraction_futurefit_db.QuizQuestion>, common_db.WithDbId<totalinteraction_futurefit_db.Skill>>[];
  questionNumber: number;
  totalQuestions: number;
}

export function makeSelfAssessmentNextQuestion(
  input: {
    competency: common_db.WithDbId<totalinteraction_futurefit_db.Competency>,
    skillQuestions: sys_types.Pair<common_db.DbKey<totalinteraction_futurefit_db.QuizQuestion>, common_db.WithDbId<totalinteraction_futurefit_db.Skill>>[],
    questionNumber: number,
    totalQuestions: number,
  }
): SelfAssessmentNextQuestion {
  return {
    competency: input.competency,
    skillQuestions: input.skillQuestions,
    questionNumber: input.questionNumber,
    totalQuestions: input.totalQuestions,
  };
}

const SelfAssessmentNextQuestion_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"competency","default":{"kind":"nothing"},"name":"competency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillQuestions","default":{"kind":"nothing"},"name":"skillQuestions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Pair"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizQuestion"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"questionNumber","default":{"kind":"nothing"},"name":"questionNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"totalQuestions","default":{"kind":"nothing"},"name":"totalQuestions","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"SelfAssessmentNextQuestion","version":{"kind":"nothing"}}};

export const snSelfAssessmentNextQuestion: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SelfAssessmentNextQuestion"};

export function texprSelfAssessmentNextQuestion(): ADL.ATypeExpr<SelfAssessmentNextQuestion> {
  return {value : {typeRef : {kind: "reference", value : snSelfAssessmentNextQuestion}, parameters : []}};
}

export type AnswerType = totalinteraction_futurefit_db.AnswerVariant<common.Unit, common.Unit, common.Unit, common.Unit>;

const AnswerType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerVariant"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}}},"name":"AnswerType","version":{"kind":"nothing"}}};

export const snAnswerType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"AnswerType"};

export function texprAnswerType(): ADL.ATypeExpr<AnswerType> {
  return {value : {typeRef : {kind: "reference", value : snAnswerType}, parameters : []}};
}

/**
 * userId and list of recommendations, plus associated Competency/Skill links
 * Same as UserTrainingOfferingsData but without the TrainingOffering map
 */
export interface UserRecommendations {
  /**
   * User for recommendations
   */
  appUserId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>;
  /**
   * Table (optional) of relevant CompetencySkillTrainingOffering data
   * The key is either a DbKey&lt;Competency&gt; or a DbKey&lt;Skill&gt;
   */
  competencySkillMap: common.StringKeyMap<string, totalinteraction_futurefit_db.CompetencySkillTrainingOffering[]>;
  /**
   * Relevant UserTrainingOffering rows (refers into offerings table via DbKey&lt;TrainingOffering&gt;)
   */
  recommendations: Recommendation[];
}

export function makeUserRecommendations(
  input: {
    appUserId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>,
    competencySkillMap: common.StringKeyMap<string, totalinteraction_futurefit_db.CompetencySkillTrainingOffering[]>,
    recommendations: Recommendation[],
  }
): UserRecommendations {
  return {
    appUserId: input.appUserId,
    competencySkillMap: input.competencySkillMap,
    recommendations: input.recommendations,
  };
}

const UserRecommendations_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"competencySkillMap","default":{"kind":"nothing"},"name":"competencySkillMap","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"CompetencySkillTrainingOffering"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"recommendations","default":{"kind":"nothing"},"name":"recommendations","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Recommendation"}},"parameters":[]}]}}]}},"name":"UserRecommendations","version":{"kind":"nothing"}}};

export const snUserRecommendations: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"UserRecommendations"};

export function texprUserRecommendations(): ADL.ATypeExpr<UserRecommendations> {
  return {value : {typeRef : {kind: "reference", value : snUserRecommendations}, parameters : []}};
}

export interface SingleUserTrainingRecommendations {
  user: UserRecommendations;
  data: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, totalinteraction_futurefit_db.TrainingOffering>;
}

export function makeSingleUserTrainingRecommendations(
  input: {
    user: UserRecommendations,
    data: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, totalinteraction_futurefit_db.TrainingOffering>,
  }
): SingleUserTrainingRecommendations {
  return {
    user: input.user,
    data: input.data,
  };
}

const SingleUserTrainingRecommendations_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"user","default":{"kind":"nothing"},"name":"user","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"UserRecommendations"}},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}}]}},"name":"SingleUserTrainingRecommendations","version":{"kind":"nothing"}}};

export const snSingleUserTrainingRecommendations: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SingleUserTrainingRecommendations"};

export function texprSingleUserTrainingRecommendations(): ADL.ATypeExpr<SingleUserTrainingRecommendations> {
  return {value : {typeRef : {kind: "reference", value : snSingleUserTrainingRecommendations}, parameters : []}};
}

export interface MultiUserTrainingRecommendations {
  users: UserRecommendations[];
  data: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, totalinteraction_futurefit_db.TrainingOffering>;
}

export function makeMultiUserTrainingRecommendations(
  input: {
    users: UserRecommendations[],
    data: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, totalinteraction_futurefit_db.TrainingOffering>,
  }
): MultiUserTrainingRecommendations {
  return {
    users: input.users,
    data: input.data,
  };
}

const MultiUserTrainingRecommendations_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"users","default":{"kind":"nothing"},"name":"users","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"UserRecommendations"}},"parameters":[]}]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}}]}},"name":"MultiUserTrainingRecommendations","version":{"kind":"nothing"}}};

export const snMultiUserTrainingRecommendations: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"MultiUserTrainingRecommendations"};

export function texprMultiUserTrainingRecommendations(): ADL.ATypeExpr<MultiUserTrainingRecommendations> {
  return {value : {typeRef : {kind: "reference", value : snMultiUserTrainingRecommendations}, parameters : []}};
}

export interface Recommendation {
  trainingOfferingId: common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>;
  result: RecommendationResult;
  completed: boolean;
}

export function makeRecommendation(
  input: {
    trainingOfferingId: common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>,
    result: RecommendationResult,
    completed: boolean,
  }
): Recommendation {
  return {
    trainingOfferingId: input.trainingOfferingId,
    result: input.result,
    completed: input.completed,
  };
}

const Recommendation_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"trainingOfferingId","default":{"kind":"nothing"},"name":"trainingOfferingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}},{"annotations":[],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"RecommendationResult"}},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"Recommendation","version":{"kind":"nothing"}}};

export const snRecommendation: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Recommendation"};

export function texprRecommendation(): ADL.ATypeExpr<Recommendation> {
  return {value : {typeRef : {kind: "reference", value : snRecommendation}, parameters : []}};
}

export interface RecommendationResult_Priority {
  kind: 'priority';
  value: number;
}
export interface RecommendationResult_RoleScore {
  kind: 'roleScore';
  value: totalinteraction_futurefit_db.RoleScore;
}

export type RecommendationResult = RecommendationResult_Priority | RecommendationResult_RoleScore;

const RecommendationResult_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"priority","default":{"kind":"nothing"},"name":"priority","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"roleScore","default":{"kind":"nothing"},"name":"roleScore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RoleScore"}},"parameters":[]}}]}},"name":"RecommendationResult","version":{"kind":"nothing"}}};

export const snRecommendationResult: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RecommendationResult"};

export function texprRecommendationResult(): ADL.ATypeExpr<RecommendationResult> {
  return {value : {typeRef : {kind: "reference", value : snRecommendationResult}, parameters : []}};
}

export interface AppClientListEntry {
  id: common_db.DbKey<totalinteraction_futurefit_db.AppClient>;
  name: string;
  logoUrl: string;
  domainName: string;
  recommendations: boolean;
  walkthroughsEnabled: boolean;
  licence: AppClientListLicenceStatus;
  licenceStart: (common.Instant|null);
  licenceEnd: (common.Instant|null);
  /**
   * TODO: To be removed?
   */
  appClient: common_db.WithDbId<totalinteraction_futurefit_db.AppClient>;
  totalActiveUsers: number;
  licenceActiveUsers: number;
}

export function makeAppClientListEntry(
  input: {
    id: common_db.DbKey<totalinteraction_futurefit_db.AppClient>,
    name: string,
    logoUrl: string,
    domainName: string,
    recommendations: boolean,
    walkthroughsEnabled: boolean,
    licence: AppClientListLicenceStatus,
    licenceStart: (common.Instant|null),
    licenceEnd: (common.Instant|null),
    appClient: common_db.WithDbId<totalinteraction_futurefit_db.AppClient>,
    totalActiveUsers: number,
    licenceActiveUsers: number,
  }
): AppClientListEntry {
  return {
    id: input.id,
    name: input.name,
    logoUrl: input.logoUrl,
    domainName: input.domainName,
    recommendations: input.recommendations,
    walkthroughsEnabled: input.walkthroughsEnabled,
    licence: input.licence,
    licenceStart: input.licenceStart,
    licenceEnd: input.licenceEnd,
    appClient: input.appClient,
    totalActiveUsers: input.totalActiveUsers,
    licenceActiveUsers: input.licenceActiveUsers,
  };
}

const AppClientListEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"logoUrl","default":{"kind":"nothing"},"name":"logoUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"domainName","default":{"kind":"nothing"},"name":"domainName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"recommendations","default":{"kind":"nothing"},"name":"recommendations","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"walkthroughsEnabled","default":{"kind":"nothing"},"name":"walkthroughsEnabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"licence","default":{"kind":"nothing"},"name":"licence","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"AppClientListLicenceStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"licenceStart","default":{"kind":"nothing"},"name":"licenceStart","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"licenceEnd","default":{"kind":"nothing"},"name":"licenceEnd","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"appClient","default":{"kind":"nothing"},"name":"appClient","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"totalActiveUsers","default":{"kind":"nothing"},"name":"totalActiveUsers","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"licenceActiveUsers","default":{"kind":"nothing"},"name":"licenceActiveUsers","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}]}},"name":"AppClientListEntry","version":{"kind":"nothing"}}};

export const snAppClientListEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"AppClientListEntry"};

export function texprAppClientListEntry(): ADL.ATypeExpr<AppClientListEntry> {
  return {value : {typeRef : {kind: "reference", value : snAppClientListEntry}, parameters : []}};
}

export enum AppClientListLicenceStatus {
  active,
  suspended,
  noLicence,
}

const AppClientListLicenceStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"active","default":{"kind":"nothing"},"name":"active","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"suspended","default":{"kind":"nothing"},"name":"suspended","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"noLicence","default":{"kind":"nothing"},"name":"noLicence","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AppClientListLicenceStatus","version":{"kind":"nothing"}}};

export const snAppClientListLicenceStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"AppClientListLicenceStatus"};

export function texprAppClientListLicenceStatus(): ADL.ATypeExpr<AppClientListLicenceStatus> {
  return {value : {typeRef : {kind: "reference", value : snAppClientListLicenceStatus}, parameters : []}};
}

export interface AppUserListEntry {
  id: common_db.DbKey<totalinteraction_futurefit_db.AppUser>;
  fullname: string;
  email: string;
  role: totalinteraction_futurefit_db.ApplicationRole;
  status: totalinteraction_futurefit_db.AppUserStatus;
  memberOf: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupMember>[];
  managerOf: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupManager>[];
  quizzes: common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>[];
  /**
   * The user this AppUser reports to (see AppUser.managerId)
   */
  managerId: (common_db.DbKey<totalinteraction_futurefit_db.AppUser>|null);
}

export function makeAppUserListEntry(
  input: {
    id: common_db.DbKey<totalinteraction_futurefit_db.AppUser>,
    fullname: string,
    email: string,
    role: totalinteraction_futurefit_db.ApplicationRole,
    status: totalinteraction_futurefit_db.AppUserStatus,
    memberOf: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupMember>[],
    managerOf: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupManager>[],
    quizzes: common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>[],
    managerId?: (common_db.DbKey<totalinteraction_futurefit_db.AppUser>|null),
  }
): AppUserListEntry {
  return {
    id: input.id,
    fullname: input.fullname,
    email: input.email,
    role: input.role,
    status: input.status,
    memberOf: input.memberOf,
    managerOf: input.managerOf,
    quizzes: input.quizzes,
    managerId: input.managerId === undefined ? null : input.managerId,
  };
}

const AppUserListEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"role","default":{"kind":"nothing"},"name":"role","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"ApplicationRole"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUserStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"memberOf","default":{"kind":"nothing"},"name":"memberOf","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupMember"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"managerOf","default":{"kind":"nothing"},"name":"managerOf","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupManager"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"quizzes","default":{"kind":"nothing"},"name":"quizzes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"managerId","default":{"kind":"just","value":null},"name":"managerId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}]}}]}},"name":"AppUserListEntry","version":{"kind":"nothing"}}};

export const snAppUserListEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"AppUserListEntry"};

export function texprAppUserListEntry(): ADL.ATypeExpr<AppUserListEntry> {
  return {value : {typeRef : {kind: "reference", value : snAppUserListEntry}, parameters : []}};
}

export interface UserGroupListEntry {
  id: common_db.DbKey<totalinteraction_futurefit_db.UserGroup>;
  name: string;
  isGlobal: boolean;
  members: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupMember>[];
  managers: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupManager>[];
  quizzes: common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>[];
}

export function makeUserGroupListEntry(
  input: {
    id: common_db.DbKey<totalinteraction_futurefit_db.UserGroup>,
    name: string,
    isGlobal: boolean,
    members: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupMember>[],
    managers: common_db.WithDbId<totalinteraction_futurefit_db.UserGroupManager>[],
    quizzes: common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>[],
  }
): UserGroupListEntry {
  return {
    id: input.id,
    name: input.name,
    isGlobal: input.isGlobal,
    members: input.members,
    managers: input.managers,
    quizzes: input.quizzes,
  };
}

const UserGroupListEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"isGlobal","default":{"kind":"nothing"},"name":"isGlobal","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"members","default":{"kind":"nothing"},"name":"members","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupMember"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"managers","default":{"kind":"nothing"},"name":"managers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupManager"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"quizzes","default":{"kind":"nothing"},"name":"quizzes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}]}}]}},"name":"UserGroupListEntry","version":{"kind":"nothing"}}};

export const snUserGroupListEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"UserGroupListEntry"};

export function texprUserGroupListEntry(): ADL.ATypeExpr<UserGroupListEntry> {
  return {value : {typeRef : {kind: "reference", value : snUserGroupListEntry}, parameters : []}};
}

export interface WorkRoleListEntry {
  id: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>;
  name: totalinteraction_futurefit_db.I18nContent;
  /**
   * Short name - for use in tight spaces
   */
  shortname: totalinteraction_futurefit_db.I18nContent;
  owner: totalinteraction_futurefit_db.Owner;
  appClient: (WorkRoleAppClient|null);
  recommendationMethod: totalinteraction_futurefit_db.RoleRecommendationMethod;
  recommendationProviders: common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>[];
  scoreRanges: common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleScoreRange>[];
}

export function makeWorkRoleListEntry(
  input: {
    id: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>,
    name: totalinteraction_futurefit_db.I18nContent,
    shortname: totalinteraction_futurefit_db.I18nContent,
    owner: totalinteraction_futurefit_db.Owner,
    appClient: (WorkRoleAppClient|null),
    recommendationMethod: totalinteraction_futurefit_db.RoleRecommendationMethod,
    recommendationProviders: common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>[],
    scoreRanges: common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleScoreRange>[],
  }
): WorkRoleListEntry {
  return {
    id: input.id,
    name: input.name,
    shortname: input.shortname,
    owner: input.owner,
    appClient: input.appClient,
    recommendationMethod: input.recommendationMethod,
    recommendationProviders: input.recommendationProviders,
    scoreRanges: input.scoreRanges,
  };
}

const WorkRoleListEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"shortname","default":{"kind":"nothing"},"name":"shortname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"owner","default":{"kind":"nothing"},"name":"owner","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Owner"}},"parameters":[]}},{"annotations":[],"serializedName":"appClient","default":{"kind":"nothing"},"name":"appClient","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"WorkRoleAppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"recommendationMethod","default":{"kind":"nothing"},"name":"recommendationMethod","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RoleRecommendationMethod"}},"parameters":[]}},{"annotations":[],"serializedName":"recommendationProviders","default":{"kind":"nothing"},"name":"recommendationProviders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"scoreRanges","default":{"kind":"nothing"},"name":"scoreRanges","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRoleScoreRange"}},"parameters":[]}]}]}}]}},"name":"WorkRoleListEntry","version":{"kind":"nothing"}}};

export const snWorkRoleListEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"WorkRoleListEntry"};

export function texprWorkRoleListEntry(): ADL.ATypeExpr<WorkRoleListEntry> {
  return {value : {typeRef : {kind: "reference", value : snWorkRoleListEntry}, parameters : []}};
}

/**
 * Subset of AppClient for WorkRoleListEntry - don't include
 * stuff that is sensitive or not required
 */
export interface WorkRoleAppClient {
  appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>;
  name: string;
  domainName: string;
  providerIds: common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>[];
}

export function makeWorkRoleAppClient(
  input: {
    appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>,
    name: string,
    domainName: string,
    providerIds: common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>[],
  }
): WorkRoleAppClient {
  return {
    appClientId: input.appClientId,
    name: input.name,
    domainName: input.domainName,
    providerIds: input.providerIds,
  };
}

const WorkRoleAppClient_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"domainName","default":{"kind":"nothing"},"name":"domainName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"providerIds","default":{"kind":"nothing"},"name":"providerIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}]}}]}},"name":"WorkRoleAppClient","version":{"kind":"nothing"}}};

export const snWorkRoleAppClient: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"WorkRoleAppClient"};

export function texprWorkRoleAppClient(): ADL.ATypeExpr<WorkRoleAppClient> {
  return {value : {typeRef : {kind: "reference", value : snWorkRoleAppClient}, parameters : []}};
}

/**
 * Used to help with sparse arrays/matrices where skills are
 * available but only some are used - and all are required in UI
 * for maintenance
 * Used for maintenance of WorkRoleSkill and (Competency)SkillTrainingOffering and in integration tests
 * eg. item = WorkRoleSkill; attribute = Skill
 */
export interface Assigned<A, T> {
  item: common_db.WithDbId<T>;
  attribute: common_db.WithDbId<A>;
}

export function makeAssigned<A, T>(
  input: {
    item: common_db.WithDbId<T>,
    attribute: common_db.WithDbId<A>,
  }
): Assigned<A, T> {
  return {
    item: input.item,
    attribute: input.attribute,
  };
}

const Assigned_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["A","T"],"fields":[{"annotations":[],"serializedName":"item","default":{"kind":"nothing"},"name":"item","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"attribute","default":{"kind":"nothing"},"name":"attribute","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"A"},"parameters":[]}]}}]}},"name":"Assigned","version":{"kind":"nothing"}}};

export const snAssigned: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Assigned"};

export function texprAssigned<A, T>(texprA : ADL.ATypeExpr<A>, texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<Assigned<A, T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.frontend",name : "Assigned"}}, parameters : [texprA.value, texprT.value]}};
}

/**
 * eg. Skill
 */
export interface Unassigned<A> {
  attribute: common_db.WithDbId<A>;
}

export function makeUnassigned<A>(
  input: {
    attribute: common_db.WithDbId<A>,
  }
): Unassigned<A> {
  return {
    attribute: input.attribute,
  };
}

const Unassigned_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["A"],"fields":[{"annotations":[],"serializedName":"attribute","default":{"kind":"nothing"},"name":"attribute","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"A"},"parameters":[]}]}}]}},"name":"Unassigned","version":{"kind":"nothing"}}};

export const snUnassigned: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Unassigned"};

export function texprUnassigned<A>(texprA : ADL.ATypeExpr<A>): ADL.ATypeExpr<Unassigned<A>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.frontend",name : "Unassigned"}}, parameters : [texprA.value]}};
}

export interface Available_Assigned<A, T> {
  kind: 'assigned';
  value: Assigned<A, T>;
}
export interface Available_Unassigned<A, _T> {
  kind: 'unassigned';
  value: Unassigned<A>;
}

export type Available<A, T> = Available_Assigned<A, T> | Available_Unassigned<A, T>;

const Available_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["A","T"],"fields":[{"annotations":[],"serializedName":"assigned","default":{"kind":"nothing"},"name":"assigned","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Assigned"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"A"},"parameters":[]},{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"unassigned","default":{"kind":"nothing"},"name":"unassigned","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Unassigned"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"A"},"parameters":[]}]}}]}},"name":"Available","version":{"kind":"nothing"}}};

export const snAvailable: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Available"};

export function texprAvailable<A, T>(texprA : ADL.ATypeExpr<A>, texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<Available<A, T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.frontend",name : "Available"}}, parameters : [texprA.value, texprT.value]}};
}

export enum ActionType {
  create,
  update,
  delete,
  loaded,
}

const ActionType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"create","default":{"kind":"nothing"},"name":"create","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"update","default":{"kind":"nothing"},"name":"update","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delete","default":{"kind":"nothing"},"name":"delete","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"loaded","default":{"kind":"nothing"},"name":"loaded","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ActionType","version":{"kind":"nothing"}}};

export const snActionType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"ActionType"};

export function texprActionType(): ADL.ATypeExpr<ActionType> {
  return {value : {typeRef : {kind: "reference", value : snActionType}, parameters : []}};
}

export interface ChangeState_New<T> {
  kind: 'new';
  value: T;
}
export interface ChangeState_Update<T> {
  kind: 'update';
  value: common_db.WithDbId<T>;
}
export interface ChangeState_Delete<T> {
  kind: 'delete';
  value: common_db.DbKey<T>;
}

export type ChangeState<T> = ChangeState_New<T> | ChangeState_Update<T> | ChangeState_Delete<T>;

const ChangeState_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"new","default":{"kind":"nothing"},"name":"new","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}},{"annotations":[],"serializedName":"update","default":{"kind":"nothing"},"name":"update","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"delete","default":{"kind":"nothing"},"name":"delete","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}}]}},"name":"ChangeState","version":{"kind":"nothing"}}};

export const snChangeState: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"ChangeState"};

export function texprChangeState<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<ChangeState<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.frontend",name : "ChangeState"}}, parameters : [texprT.value]}};
}

/**
 * Info about a quiz from perspective of a work role
 */
export interface WorkRoleQuizData {
  quiz: common_db.WithDbId<totalinteraction_futurefit_db.Quiz>;
  /**
   * Contains info on whether started or completed etc
   */
  userQuizzes: common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>[];
}

export function makeWorkRoleQuizData(
  input: {
    quiz: common_db.WithDbId<totalinteraction_futurefit_db.Quiz>,
    userQuizzes: common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>[],
  }
): WorkRoleQuizData {
  return {
    quiz: input.quiz,
    userQuizzes: input.userQuizzes,
  };
}

const WorkRoleQuizData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quiz","default":{"kind":"nothing"},"name":"quiz","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userQuizzes","default":{"kind":"nothing"},"name":"userQuizzes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}]}}]}},"name":"WorkRoleQuizData","version":{"kind":"nothing"}}};

export const snWorkRoleQuizData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"WorkRoleQuizData"};

export function texprWorkRoleQuizData(): ADL.ATypeExpr<WorkRoleQuizData> {
  return {value : {typeRef : {kind: "reference", value : snWorkRoleQuizData}, parameters : []}};
}

/**
 * For supporting SkillTrainingOfferings in the SkillEditor, and simplifying 
 * SkillForm etc
 */
export interface SkillData {
  availableTrainingOfferings: common_db.WithDbId<totalinteraction_futurefit_db.SkillTrainingOffering>[];
  trainingOfferings: common_db.WithDbId<totalinteraction_futurefit_db.TrainingOffering>[];
  competencies: common_db.WithDbId<totalinteraction_futurefit_db.Competency>[];
}

export function makeSkillData(
  input: {
    availableTrainingOfferings: common_db.WithDbId<totalinteraction_futurefit_db.SkillTrainingOffering>[],
    trainingOfferings: common_db.WithDbId<totalinteraction_futurefit_db.TrainingOffering>[],
    competencies: common_db.WithDbId<totalinteraction_futurefit_db.Competency>[],
  }
): SkillData {
  return {
    availableTrainingOfferings: input.availableTrainingOfferings,
    trainingOfferings: input.trainingOfferings,
    competencies: input.competencies,
  };
}

const SkillData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"availableTrainingOfferings","default":{"kind":"nothing"},"name":"availableTrainingOfferings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"SkillTrainingOffering"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"trainingOfferings","default":{"kind":"nothing"},"name":"trainingOfferings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"competencies","default":{"kind":"nothing"},"name":"competencies","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}]}}]}},"name":"SkillData","version":{"kind":"nothing"}}};

export const snSkillData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SkillData"};

export function texprSkillData(): ADL.ATypeExpr<SkillData> {
  return {value : {typeRef : {kind: "reference", value : snSkillData}, parameters : []}};
}

/**
 * RoleBuilder - master fetch
 */
export interface RoleBuilderData {
  role: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>;
  availableSkills: Available<totalinteraction_futurefit_db.Skill, totalinteraction_futurefit_db.WorkRoleSkill>[];
  competencies: common_db.WithDbId<totalinteraction_futurefit_db.Competency>[];
  quizzes: WorkRoleQuizData[];
}

export function makeRoleBuilderData(
  input: {
    role: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>,
    availableSkills: Available<totalinteraction_futurefit_db.Skill, totalinteraction_futurefit_db.WorkRoleSkill>[],
    competencies: common_db.WithDbId<totalinteraction_futurefit_db.Competency>[],
    quizzes: WorkRoleQuizData[],
  }
): RoleBuilderData {
  return {
    role: input.role,
    availableSkills: input.availableSkills,
    competencies: input.competencies,
    quizzes: input.quizzes,
  };
}

const RoleBuilderData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"role","default":{"kind":"nothing"},"name":"role","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"availableSkills","default":{"kind":"nothing"},"name":"availableSkills","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Available"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRoleSkill"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"competencies","default":{"kind":"nothing"},"name":"competencies","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"quizzes","default":{"kind":"nothing"},"name":"quizzes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"WorkRoleQuizData"}},"parameters":[]}]}}]}},"name":"RoleBuilderData","version":{"kind":"nothing"}}};

export const snRoleBuilderData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RoleBuilderData"};

export function texprRoleBuilderData(): ADL.ATypeExpr<RoleBuilderData> {
  return {value : {typeRef : {kind: "reference", value : snRoleBuilderData}, parameters : []}};
}

/**
 * All assoc data for the t/o master list - read-only - may be limited to specific client
 */
export interface TrainingOfferingData {
  trainingOfferings: common_db.WithDbId<totalinteraction_futurefit_db.TrainingOffering>[];
  availableSkills: common_db.WithDbId<totalinteraction_futurefit_db.SkillTrainingOffering>[];
  availableCompetencies: common_db.WithDbId<totalinteraction_futurefit_db.CompetencyTrainingOffering>[];
  skills: common_db.WithDbId<totalinteraction_futurefit_db.Skill>[];
  competencies: common_db.WithDbId<totalinteraction_futurefit_db.Competency>[];
  /**
   * Roles - limited by client ID if required
   */
  roles: common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>[];
  ranges: common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleScoreRange>[];
  learningProviders: common_db.WithDbId<totalinteraction_futurefit_db.LearningProvider>[];
  catalog: common_db.WithDbId<totalinteraction_futurefit_db.LearningProviderCatalogEntry>[];
}

export function makeTrainingOfferingData(
  input: {
    trainingOfferings: common_db.WithDbId<totalinteraction_futurefit_db.TrainingOffering>[],
    availableSkills: common_db.WithDbId<totalinteraction_futurefit_db.SkillTrainingOffering>[],
    availableCompetencies: common_db.WithDbId<totalinteraction_futurefit_db.CompetencyTrainingOffering>[],
    skills: common_db.WithDbId<totalinteraction_futurefit_db.Skill>[],
    competencies: common_db.WithDbId<totalinteraction_futurefit_db.Competency>[],
    roles: common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>[],
    ranges: common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleScoreRange>[],
    learningProviders: common_db.WithDbId<totalinteraction_futurefit_db.LearningProvider>[],
    catalog: common_db.WithDbId<totalinteraction_futurefit_db.LearningProviderCatalogEntry>[],
  }
): TrainingOfferingData {
  return {
    trainingOfferings: input.trainingOfferings,
    availableSkills: input.availableSkills,
    availableCompetencies: input.availableCompetencies,
    skills: input.skills,
    competencies: input.competencies,
    roles: input.roles,
    ranges: input.ranges,
    learningProviders: input.learningProviders,
    catalog: input.catalog,
  };
}

const TrainingOfferingData_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"trainingOfferings","default":{"kind":"nothing"},"name":"trainingOfferings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"availableSkills","default":{"kind":"nothing"},"name":"availableSkills","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"SkillTrainingOffering"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"availableCompetencies","default":{"kind":"nothing"},"name":"availableCompetencies","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"CompetencyTrainingOffering"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"skills","default":{"kind":"nothing"},"name":"skills","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"competencies","default":{"kind":"nothing"},"name":"competencies","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"ranges","default":{"kind":"nothing"},"name":"ranges","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRoleScoreRange"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"learningProviders","default":{"kind":"nothing"},"name":"learningProviders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"catalog","default":{"kind":"nothing"},"name":"catalog","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProviderCatalogEntry"}},"parameters":[]}]}]}}]}},"name":"TrainingOfferingData","version":{"kind":"nothing"}}};

export const snTrainingOfferingData: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"TrainingOfferingData"};

export function texprTrainingOfferingData(): ADL.ATypeExpr<TrainingOfferingData> {
  return {value : {typeRef : {kind: "reference", value : snTrainingOfferingData}, parameters : []}};
}

/**
 * RoleBuilder - master update
 */
export interface RoleBuilderUpdates {
  roleId: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>;
  updates: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.Skill>, ChangeState<totalinteraction_futurefit_db.WorkRoleSkill>>;
}

export function makeRoleBuilderUpdates(
  input: {
    roleId: common_db.DbKey<totalinteraction_futurefit_db.WorkRole>,
    updates: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.Skill>, ChangeState<totalinteraction_futurefit_db.WorkRoleSkill>>,
  }
): RoleBuilderUpdates {
  return {
    roleId: input.roleId,
    updates: input.updates,
  };
}

const RoleBuilderUpdates_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"roleId","default":{"kind":"nothing"},"name":"roleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"updates","default":{"kind":"nothing"},"name":"updates","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"ChangeState"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRoleSkill"}},"parameters":[]}]}]}}]}},"name":"RoleBuilderUpdates","version":{"kind":"nothing"}}};

export const snRoleBuilderUpdates: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RoleBuilderUpdates"};

export function texprRoleBuilderUpdates(): ADL.ATypeExpr<RoleBuilderUpdates> {
  return {value : {typeRef : {kind: "reference", value : snRoleBuilderUpdates}, parameters : []}};
}

export interface SkillTrainingOfferingUpdateKey_TrainingOfferingId {
  kind: 'trainingOfferingId';
  value: common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>;
}
export interface SkillTrainingOfferingUpdateKey_SkillId {
  kind: 'skillId';
  value: common_db.DbKey<totalinteraction_futurefit_db.Skill>;
}

export type SkillTrainingOfferingUpdateKey = SkillTrainingOfferingUpdateKey_TrainingOfferingId | SkillTrainingOfferingUpdateKey_SkillId;

const SkillTrainingOfferingUpdateKey_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"trainingOfferingId","default":{"kind":"nothing"},"name":"trainingOfferingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillId","default":{"kind":"nothing"},"name":"skillId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}}]}},"name":"SkillTrainingOfferingUpdateKey","version":{"kind":"nothing"}}};

export const snSkillTrainingOfferingUpdateKey: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SkillTrainingOfferingUpdateKey"};

export function texprSkillTrainingOfferingUpdateKey(): ADL.ATypeExpr<SkillTrainingOfferingUpdateKey> {
  return {value : {typeRef : {kind: "reference", value : snSkillTrainingOfferingUpdateKey}, parameters : []}};
}

/**
 * ----- [ Reports ] -----------------------------------
 * FF2-134: Client Participants Report
 */
export interface ClientParticipant {
  userId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>;
  /**
   * Split from fullname
   */
  firstname: string;
  lastname: common_strings.StringNE;
  email: common_strings.StringNE;
  isManager: string;
  managerName: string;
  teamName: string;
  status: string;
  quizId: common_db.DbKey<totalinteraction_futurefit_db.Quiz>;
  quizTitle: common_strings.StringNE;
  attempt: number;
  completed: common_strings.StringNE;
  lastModified: string;
  totalTime: common_strings.StringNE;
}

export function makeClientParticipant(
  input: {
    userId: common_db.DbKey<totalinteraction_futurefit_db.AppUser>,
    firstname: string,
    lastname: common_strings.StringNE,
    email: common_strings.StringNE,
    isManager: string,
    managerName: string,
    teamName: string,
    status: string,
    quizId: common_db.DbKey<totalinteraction_futurefit_db.Quiz>,
    quizTitle: common_strings.StringNE,
    attempt: number,
    completed: common_strings.StringNE,
    lastModified: string,
    totalTime: common_strings.StringNE,
  }
): ClientParticipant {
  return {
    userId: input.userId,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
    isManager: input.isManager,
    managerName: input.managerName,
    teamName: input.teamName,
    status: input.status,
    quizId: input.quizId,
    quizTitle: input.quizTitle,
    attempt: input.attempt,
    completed: input.completed,
    lastModified: input.lastModified,
    totalTime: input.totalTime,
  };
}

const ClientParticipant_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"isManager","default":{"kind":"nothing"},"name":"isManager","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"managerName","default":{"kind":"nothing"},"name":"managerName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"teamName","default":{"kind":"nothing"},"name":"teamName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"quizId","default":{"kind":"nothing"},"name":"quizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizTitle","default":{"kind":"nothing"},"name":"quizTitle","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"attempt","default":{"kind":"nothing"},"name":"attempt","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"lastModified","default":{"kind":"nothing"},"name":"lastModified","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"totalTime","default":{"kind":"nothing"},"name":"totalTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"ClientParticipant","version":{"kind":"nothing"}}};

export const snClientParticipant: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"ClientParticipant"};

export function texprClientParticipant(): ADL.ATypeExpr<ClientParticipant> {
  return {value : {typeRef : {kind: "reference", value : snClientParticipant}, parameters : []}};
}

export interface SkillTrainingOfferingMatrixOfferingLookup {
  name: common_strings.StringNE;
  providerName: common_strings.StringNE;
}

export function makeSkillTrainingOfferingMatrixOfferingLookup(
  input: {
    name: common_strings.StringNE,
    providerName: common_strings.StringNE,
  }
): SkillTrainingOfferingMatrixOfferingLookup {
  return {
    name: input.name,
    providerName: input.providerName,
  };
}

const SkillTrainingOfferingMatrixOfferingLookup_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"providerName","default":{"kind":"nothing"},"name":"providerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"SkillTrainingOfferingMatrixOfferingLookup","version":{"kind":"nothing"}}};

export const snSkillTrainingOfferingMatrixOfferingLookup: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SkillTrainingOfferingMatrixOfferingLookup"};

export function texprSkillTrainingOfferingMatrixOfferingLookup(): ADL.ATypeExpr<SkillTrainingOfferingMatrixOfferingLookup> {
  return {value : {typeRef : {kind: "reference", value : snSkillTrainingOfferingMatrixOfferingLookup}, parameters : []}};
}

export interface SkillTrainingOfferingMatrix {
  skills: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.Skill>, common_strings.StringNE>;
  offerings: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, SkillTrainingOfferingMatrixOfferingLookup>;
  values: sys_types.Map<sys_types.Pair<common_db.DbKey<totalinteraction_futurefit_db.Skill>, common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>>, number>;
}

export function makeSkillTrainingOfferingMatrix(
  input: {
    skills: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.Skill>, common_strings.StringNE>,
    offerings: common.StringKeyMap<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, SkillTrainingOfferingMatrixOfferingLookup>,
    values: sys_types.Map<sys_types.Pair<common_db.DbKey<totalinteraction_futurefit_db.Skill>, common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>>, number>,
  }
): SkillTrainingOfferingMatrix {
  return {
    skills: input.skills,
    offerings: input.offerings,
    values: input.values,
  };
}

const SkillTrainingOfferingMatrix_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"skills","default":{"kind":"nothing"},"name":"skills","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"offerings","default":{"kind":"nothing"},"name":"offerings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringKeyMap"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"SkillTrainingOfferingMatrixOfferingLookup"}},"parameters":[]}]}},{"annotations":[],"serializedName":"values","default":{"kind":"nothing"},"name":"values","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Pair"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}]},{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}}]}},"name":"SkillTrainingOfferingMatrix","version":{"kind":"nothing"}}};

export const snSkillTrainingOfferingMatrix: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"SkillTrainingOfferingMatrix"};

export function texprSkillTrainingOfferingMatrix(): ADL.ATypeExpr<SkillTrainingOfferingMatrix> {
  return {value : {typeRef : {kind: "reference", value : snSkillTrainingOfferingMatrix}, parameters : []}};
}

/**
 * ----- [ Scodle events ] -----------------------------
 */
export interface InputEvent {
  /**
   * Encrypted and encoded in query string
   */
  data: string;
}

export function makeInputEvent(
  input: {
    data: string,
  }
): InputEvent {
  return {
    data: input.data,
  };
}

const InputEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"InputEvent","version":{"kind":"nothing"}}};

export const snInputEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"InputEvent"};

export function texprInputEvent(): ADL.ATypeExpr<InputEvent> {
  return {value : {typeRef : {kind: "reference", value : snInputEvent}, parameters : []}};
}

/**
 * ----- [ AWS Resources Management ] ------------------
 * A single bucket
 */
export interface Repository {
  repositoryName: common_strings.StringNE;
}

export function makeRepository(
  input: {
    repositoryName: common_strings.StringNE,
  }
): Repository {
  return {
    repositoryName: input.repositoryName,
  };
}

const Repository_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"repositoryName","default":{"kind":"nothing"},"name":"repositoryName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"Repository","version":{"kind":"nothing"}}};

export const snRepository: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Repository"};

export function texprRepository(): ADL.ATypeExpr<Repository> {
  return {value : {typeRef : {kind: "reference", value : snRepository}, parameters : []}};
}

/**
 * A set of addressable buckets
 */
export interface RepositoryList {
  repositories: Repository[];
}

export function makeRepositoryList(
  input: {
    repositories: Repository[],
  }
): RepositoryList {
  return {
    repositories: input.repositories,
  };
}

const RepositoryList_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"repositories","default":{"kind":"nothing"},"name":"repositories","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Repository"}},"parameters":[]}]}}]}},"name":"RepositoryList","version":{"kind":"nothing"}}};

export const snRepositoryList: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RepositoryList"};

export function texprRepositoryList(): ADL.ATypeExpr<RepositoryList> {
  return {value : {typeRef : {kind: "reference", value : snRepositoryList}, parameters : []}};
}

/**
 * A bucket object with content (file)
 */
export interface FileEntry {
  path: common_strings.StringNE;
  size: number;
  lastModified: common.Instant;
  publicUrl: common_strings.StringNE;
}

export function makeFileEntry(
  input: {
    path: common_strings.StringNE,
    size: number,
    lastModified: common.Instant,
    publicUrl: common_strings.StringNE,
  }
): FileEntry {
  return {
    path: input.path,
    size: input.size,
    lastModified: input.lastModified,
    publicUrl: input.publicUrl,
  };
}

const FileEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"size","default":{"kind":"nothing"},"name":"size","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"lastModified","default":{"kind":"nothing"},"name":"lastModified","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"publicUrl","default":{"kind":"nothing"},"name":"publicUrl","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"FileEntry","version":{"kind":"nothing"}}};

export const snFileEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"FileEntry"};

export function texprFileEntry(): ADL.ATypeExpr<FileEntry> {
  return {value : {typeRef : {kind: "reference", value : snFileEntry}, parameters : []}};
}

/**
 * A bucket prefix (zero-length and "/"-terminated)
 */
export interface PrefixEntry {
  path: common_strings.StringNE;
  lastModified: common.Instant;
}

export function makePrefixEntry(
  input: {
    path: common_strings.StringNE,
    lastModified: common.Instant,
  }
): PrefixEntry {
  return {
    path: input.path,
    lastModified: input.lastModified,
  };
}

const PrefixEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"lastModified","default":{"kind":"nothing"},"name":"lastModified","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PrefixEntry","version":{"kind":"nothing"}}};

export const snPrefixEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"PrefixEntry"};

export function texprPrefixEntry(): ADL.ATypeExpr<PrefixEntry> {
  return {value : {typeRef : {kind: "reference", value : snPrefixEntry}, parameters : []}};
}

export interface Entry_File {
  kind: 'file';
  value: FileEntry;
}
export interface Entry_Directory {
  kind: 'directory';
  value: PrefixEntry;
}

/**
 * A generic bucket object - file or prefix
 */
export type Entry = Entry_File | Entry_Directory;

const Entry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"file","default":{"kind":"nothing"},"name":"file","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"FileEntry"}},"parameters":[]}},{"annotations":[],"serializedName":"directory","default":{"kind":"nothing"},"name":"directory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"PrefixEntry"}},"parameters":[]}}]}},"name":"Entry","version":{"kind":"nothing"}}};

export const snEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Entry"};

export function texprEntry(): ADL.ATypeExpr<Entry> {
  return {value : {typeRef : {kind: "reference", value : snEntry}, parameters : []}};
}

/**
 * A simple flat filesystem. If the path is "/" it will contain all objects in the repos.
 * This 'path' is not a directory, but is used to query the list, so won't necessarily be in the list itself.
 * Thus the path "/" doesn't actually exist in a bucket. A path of "/icons" will return
 * all files with the path "icons/". A path which includes the entire key of an object
 * will return just that one object.
 */
export interface RepositoryEntries {
  repositoryName: common_strings.StringNE;
  path: common_strings.StringNE;
  entries: Entry[];
}

export function makeRepositoryEntries(
  input: {
    repositoryName: common_strings.StringNE,
    path: common_strings.StringNE,
    entries: Entry[],
  }
): RepositoryEntries {
  return {
    repositoryName: input.repositoryName,
    path: input.path,
    entries: input.entries,
  };
}

const RepositoryEntries_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"repositoryName","default":{"kind":"nothing"},"name":"repositoryName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"Entry"}},"parameters":[]}]}}]}},"name":"RepositoryEntries","version":{"kind":"nothing"}}};

export const snRepositoryEntries: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RepositoryEntries"};

export function texprRepositoryEntries(): ADL.ATypeExpr<RepositoryEntries> {
  return {value : {typeRef : {kind: "reference", value : snRepositoryEntries}, parameters : []}};
}

export type RepositoryEntrySet = {[key: string]: RepositoryEntries};

const RepositoryEntrySet_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.frontend","name":"RepositoryEntries"}},"parameters":[]}]}}},"name":"RepositoryEntrySet","version":{"kind":"nothing"}}};

export const snRepositoryEntrySet: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"RepositoryEntrySet"};

export function texprRepositoryEntrySet(): ADL.ATypeExpr<RepositoryEntrySet> {
  return {value : {typeRef : {kind: "reference", value : snRepositoryEntrySet}, parameters : []}};
}

/**
 * ----- [ Auth0 Client Management ] ----------------------
 * An Auth0 SPA client as *returned* from Auth0 - which maps to a sub-domain in skillseeker and thus a skillseeker AppClient
 * This is a subset of available fields from Auth0
 */
export interface Auth0Client {
  /**
   * This is the Auth0 Client (now "Application") ID, received back from Auth0
   */
  clientId: common_strings.StringNE;
  /**
   * This is the name that was sent to Auth0 in a Create or Update request.
   * It has to be unique in the Auth0 tenant (which maps to the Auth0 domain)
   */
  name: common_strings.StringNE;
  /**
   * Auth0 was sent a subdomain in a Create or Update request, for use in endpoints. 
   * This is not stored separately there. We receive a FQDN host back for doc purposes
   */
  host: string;
  /**
   * This isn't the flat custom domain (eg. skillseeker.io), it's the authentication sub-domain
   * (Either a custom domain like auth.skillseeker.io, or a subdomain of auth0.com)
   */
  auth0Domain: string;
  /**
   * Copy of the logo URL sent to Auth0 in a Create or Update request.
   */
  logoUri: string;
}

export function makeAuth0Client(
  input: {
    clientId: common_strings.StringNE,
    name: common_strings.StringNE,
    host: string,
    auth0Domain: string,
    logoUri: string,
  }
): Auth0Client {
  return {
    clientId: input.clientId,
    name: input.name,
    host: input.host,
    auth0Domain: input.auth0Domain,
    logoUri: input.logoUri,
  };
}

const Auth0Client_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"auth0Domain","default":{"kind":"nothing"},"name":"auth0Domain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"logoUri","default":{"kind":"nothing"},"name":"logoUri","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Auth0Client","version":{"kind":"nothing"}}};

export const snAuth0Client: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"Auth0Client"};

export function texprAuth0Client(): ADL.ATypeExpr<Auth0Client> {
  return {value : {typeRef : {kind: "reference", value : snAuth0Client}, parameters : []}};
}

export interface TrackedCourseInfo {
  executeUrl: string;
  trackedUrl: (string|null);
  courseId: (string|null);
  courseName: (string|null);
  /**
   * TODO
   * Nullable<String> trackId;
   */
  userName: (string|null);
  firstName: (string|null);
  lastName: (string|null);
  userEmail: (string|null);
}

export function makeTrackedCourseInfo(
  input: {
    executeUrl: string,
    trackedUrl: (string|null),
    courseId: (string|null),
    courseName: (string|null),
    userName: (string|null),
    firstName: (string|null),
    lastName: (string|null),
    userEmail: (string|null),
  }
): TrackedCourseInfo {
  return {
    executeUrl: input.executeUrl,
    trackedUrl: input.trackedUrl,
    courseId: input.courseId,
    courseName: input.courseName,
    userName: input.userName,
    firstName: input.firstName,
    lastName: input.lastName,
    userEmail: input.userEmail,
  };
}

const TrackedCourseInfo_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.frontend","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"executeUrl","default":{"kind":"nothing"},"name":"executeUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"trackedUrl","default":{"kind":"nothing"},"name":"trackedUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"courseId","default":{"kind":"nothing"},"name":"courseId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"courseName","default":{"kind":"nothing"},"name":"courseName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"userName","default":{"kind":"nothing"},"name":"userName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"firstName","default":{"kind":"nothing"},"name":"firstName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"lastName","default":{"kind":"nothing"},"name":"lastName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"userEmail","default":{"kind":"nothing"},"name":"userEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"TrackedCourseInfo","version":{"kind":"nothing"}}};

export const snTrackedCourseInfo: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.frontend", name:"TrackedCourseInfo"};

export function texprTrackedCourseInfo(): ADL.ATypeExpr<TrackedCourseInfo> {
  return {value : {typeRef : {kind: "reference", value : snTrackedCourseInfo}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.frontend.Competency" : Competency_AST,
  "totalinteraction.futurefit.frontend.CompetencySkillsMap" : CompetencySkillsMap_AST,
  "totalinteraction.futurefit.frontend.ResultsScoreSet" : ResultsScoreSet_AST,
  "totalinteraction.futurefit.frontend.QuizMapAndScores" : QuizMapAndScores_AST,
  "totalinteraction.futurefit.frontend.RoleMapAndScores" : RoleMapAndScores_AST,
  "totalinteraction.futurefit.frontend.AppUserData" : AppUserData_AST,
  "totalinteraction.futurefit.frontend.UsersGroupsMap" : UsersGroupsMap_AST,
  "totalinteraction.futurefit.frontend.UserQuizResults" : UserQuizResults_AST,
  "totalinteraction.futurefit.frontend.SingleUserQuizResults" : SingleUserQuizResults_AST,
  "totalinteraction.futurefit.frontend.MultiUserQuizResults" : MultiUserQuizResults_AST,
  "totalinteraction.futurefit.frontend.ComparisonRoles" : ComparisonRoles_AST,
  "totalinteraction.futurefit.frontend.RoleData" : RoleData_AST,
  "totalinteraction.futurefit.frontend.UserQuizData" : UserQuizData_AST,
  "totalinteraction.futurefit.frontend.UserQuizSummary" : UserQuizSummary_AST,
  "totalinteraction.futurefit.frontend.AssessmentStatus" : AssessmentStatus_AST,
  "totalinteraction.futurefit.frontend.QuizNextQuestion" : QuizNextQuestion_AST,
  "totalinteraction.futurefit.frontend.SelfAssessmentNextQuestion" : SelfAssessmentNextQuestion_AST,
  "totalinteraction.futurefit.frontend.AnswerType" : AnswerType_AST,
  "totalinteraction.futurefit.frontend.UserRecommendations" : UserRecommendations_AST,
  "totalinteraction.futurefit.frontend.SingleUserTrainingRecommendations" : SingleUserTrainingRecommendations_AST,
  "totalinteraction.futurefit.frontend.MultiUserTrainingRecommendations" : MultiUserTrainingRecommendations_AST,
  "totalinteraction.futurefit.frontend.Recommendation" : Recommendation_AST,
  "totalinteraction.futurefit.frontend.RecommendationResult" : RecommendationResult_AST,
  "totalinteraction.futurefit.frontend.AppClientListEntry" : AppClientListEntry_AST,
  "totalinteraction.futurefit.frontend.AppClientListLicenceStatus" : AppClientListLicenceStatus_AST,
  "totalinteraction.futurefit.frontend.AppUserListEntry" : AppUserListEntry_AST,
  "totalinteraction.futurefit.frontend.UserGroupListEntry" : UserGroupListEntry_AST,
  "totalinteraction.futurefit.frontend.WorkRoleListEntry" : WorkRoleListEntry_AST,
  "totalinteraction.futurefit.frontend.WorkRoleAppClient" : WorkRoleAppClient_AST,
  "totalinteraction.futurefit.frontend.Assigned" : Assigned_AST,
  "totalinteraction.futurefit.frontend.Unassigned" : Unassigned_AST,
  "totalinteraction.futurefit.frontend.Available" : Available_AST,
  "totalinteraction.futurefit.frontend.ActionType" : ActionType_AST,
  "totalinteraction.futurefit.frontend.ChangeState" : ChangeState_AST,
  "totalinteraction.futurefit.frontend.WorkRoleQuizData" : WorkRoleQuizData_AST,
  "totalinteraction.futurefit.frontend.SkillData" : SkillData_AST,
  "totalinteraction.futurefit.frontend.RoleBuilderData" : RoleBuilderData_AST,
  "totalinteraction.futurefit.frontend.TrainingOfferingData" : TrainingOfferingData_AST,
  "totalinteraction.futurefit.frontend.RoleBuilderUpdates" : RoleBuilderUpdates_AST,
  "totalinteraction.futurefit.frontend.SkillTrainingOfferingUpdateKey" : SkillTrainingOfferingUpdateKey_AST,
  "totalinteraction.futurefit.frontend.ClientParticipant" : ClientParticipant_AST,
  "totalinteraction.futurefit.frontend.SkillTrainingOfferingMatrixOfferingLookup" : SkillTrainingOfferingMatrixOfferingLookup_AST,
  "totalinteraction.futurefit.frontend.SkillTrainingOfferingMatrix" : SkillTrainingOfferingMatrix_AST,
  "totalinteraction.futurefit.frontend.InputEvent" : InputEvent_AST,
  "totalinteraction.futurefit.frontend.Repository" : Repository_AST,
  "totalinteraction.futurefit.frontend.RepositoryList" : RepositoryList_AST,
  "totalinteraction.futurefit.frontend.FileEntry" : FileEntry_AST,
  "totalinteraction.futurefit.frontend.PrefixEntry" : PrefixEntry_AST,
  "totalinteraction.futurefit.frontend.Entry" : Entry_AST,
  "totalinteraction.futurefit.frontend.RepositoryEntries" : RepositoryEntries_AST,
  "totalinteraction.futurefit.frontend.RepositoryEntrySet" : RepositoryEntrySet_AST,
  "totalinteraction.futurefit.frontend.Auth0Client" : Auth0Client_AST,
  "totalinteraction.futurefit.frontend.TrackedCourseInfo" : TrackedCourseInfo_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/frontend.ts